var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns has-text-centered justify-center"},[_c('div',{staticClass:"column"},[_c('pie-chart',{attrs:{"chart-data":_vm.pieChartData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }